import { FC, ReactNode } from "react";

export const ModalBody: FC<{ children: ReactNode }> = (props) => {
  return <div className="py-6 px-12">{props.children}</div>;
};
